import { createContext } from 'react';
import defaultPropsDecorator from './defaultPropsDecorator';
export var PropsDecoratorContext = createContext(defaultPropsDecorator);
export default PropsDecoratorContext.Provider;